import React from "react"

// Layout
import MainLayout from "src/layouts/mainLayout"

import Head from "next/head"
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"
import Transactions from "../../../components/pages/transactions/transactions"

const TransactionsPage = () => {
  return (
    <>
      <Head>
        <title>تراکنش ها</title>
      </Head>

      <Transactions />
    </>
  )
}

TransactionsPage.Layout = MainLayout

export default TransactionsPage

export async function getServerSideProps(context) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}

